const now = new Date();

const startOfWeek = (date) => {
  const d = new Date(date);
  d.setDate(d.getDate() - d.getDay());
  d.setHours(0, 0, 0, 0);
  return d;
};

const startOfMonth = (date) => new Date(date.getFullYear(), date.getMonth(), 1);
const startOfQuarter = (date) =>
  new Date(date.getFullYear(), Math.floor(date.getMonth() / 3) * 3, 1);
const startOfYear = (date) => new Date(date.getFullYear(), 0, 1);
const addDays = (date, days) => new Date(date.getTime() + days * 86400000);
const startOfDay = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());
const endOfDay = (date) =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59);

const formatToIsoString = (date) => date.toISOString();

export const dateRanges = {
  'all-dates': { label: 'All Dates', value: { startDate: null, endDate: null } },
  'custom-dates': { label: 'Custom dates', value: { startDate: null, endDate: null } },
  today: {
    label: 'Today',
    value: {
      startDate: formatToIsoString(startOfDay(now)),
      endDate: formatToIsoString(endOfDay(now))
    }
  },
  'this-week': {
    label: 'This week',
    value: {
      startDate: formatToIsoString(startOfWeek(now)),
      endDate: formatToIsoString(addDays(startOfWeek(now), 6))
    }
  },
  'this-week-to-date': {
    label: 'This week to date',
    value: { startDate: formatToIsoString(startOfWeek(now)), endDate: formatToIsoString(now) }
  },
  'this-month': {
    label: 'This month',
    value: {
      startDate: formatToIsoString(startOfMonth(now)),
      endDate: formatToIsoString(new Date(now.getFullYear(), now.getMonth() + 1, 0))
    }
  },
  'this-month-to-date': {
    label: 'This month to date',
    value: { startDate: formatToIsoString(startOfMonth(now)), endDate: formatToIsoString(now) }
  },
  'this-quarter': {
    label: 'This quarter',
    value: {
      startDate: formatToIsoString(startOfQuarter(now)),
      endDate: formatToIsoString(addDays(startOfQuarter(now), 89))
    }
  },
  'this-quarter-to-date': {
    label: 'This quarter to date',
    value: { startDate: formatToIsoString(startOfQuarter(now)), endDate: formatToIsoString(now) }
  },
  'this-year': {
    label: 'This year',
    value: {
      startDate: formatToIsoString(startOfYear(now)),
      endDate: formatToIsoString(new Date(now.getFullYear(), 11, 31))
    }
  },
  'this-year-to-date': {
    label: 'This year to date',
    value: { startDate: formatToIsoString(startOfYear(now)), endDate: formatToIsoString(now) }
  },
  yesterday: {
    label: 'Yesterday',
    value: {
      startDate: formatToIsoString(addDays(now, -1)),
      endDate: formatToIsoString(addDays(now, -1))
    }
  },
  'last-week': {
    label: 'Last week',
    value: {
      startDate: formatToIsoString(addDays(startOfWeek(now), -7)),
      endDate: formatToIsoString(addDays(startOfWeek(now), -1))
    }
  },
  'last-week-to-date': {
    label: 'Last week to date',
    value: {
      startDate: formatToIsoString(addDays(startOfWeek(now), -7)),
      endDate: formatToIsoString(now)
    }
  },
  'last-month': {
    label: 'Last month',
    value: {
      startDate: formatToIsoString(startOfMonth(addDays(now, -30))),
      endDate: formatToIsoString(addDays(startOfMonth(now), -1))
    }
  },
  'last-month-to-date': {
    label: 'Last month to date',
    value: {
      startDate: formatToIsoString(startOfMonth(addDays(now, -30))),
      endDate: formatToIsoString(now)
    }
  },
  'last-7-days': {
    label: 'Last 7 days',
    value: { startDate: formatToIsoString(addDays(now, -6)), endDate: formatToIsoString(now) }
  },
  'last-30-days': {
    label: 'Last 30 days',
    value: { startDate: formatToIsoString(addDays(now, -29)), endDate: formatToIsoString(now) }
  },
  'last-90-days': {
    label: 'Last 90 days',
    value: { startDate: formatToIsoString(addDays(now, -89)), endDate: formatToIsoString(now) }
  },
  'last-12-months': {
    label: 'Last 12 months',
    value: { startDate: formatToIsoString(addDays(now, -365)), endDate: formatToIsoString(now) }
  },
  'since-30-days-ago': {
    label: 'Since 30 days ago',
    value: { startDate: formatToIsoString(addDays(now, -30)), endDate: formatToIsoString(now) }
  },
  'since-60-days-ago': {
    label: 'Since 60 days ago',
    value: { startDate: formatToIsoString(addDays(now, -60)), endDate: formatToIsoString(now) }
  },
  'since-90-days-ago': {
    label: 'Since 90 days ago',
    value: { startDate: formatToIsoString(addDays(now, -90)), endDate: formatToIsoString(now) }
  },
  'since-365-days-ago': {
    label: 'Since 365 days ago',
    value: { startDate: formatToIsoString(addDays(now, -365)), endDate: formatToIsoString(now) }
  },
  'next-week': {
    label: 'Next week',
    value: {
      startDate: formatToIsoString(addDays(startOfWeek(now), 7)),
      endDate: formatToIsoString(addDays(startOfWeek(now), 13))
    }
  },
  'next-4-weeks': {
    label: 'Next 4 weeks',
    value: {
      startDate: formatToIsoString(addDays(now, 1)),
      endDate: formatToIsoString(addDays(now, 28))
    }
  },
  'next-month': {
    label: 'Next month',
    value: {
      startDate: formatToIsoString(new Date(now.getFullYear(), now.getMonth() + 1, 1)),
      endDate: formatToIsoString(new Date(now.getFullYear(), now.getMonth() + 2, 0))
    }
  },
  'next-quarter': {
    label: 'Next quarter',
    value: {
      startDate: formatToIsoString(startOfQuarter(addDays(now, 90))),
      endDate: formatToIsoString(addDays(startOfQuarter(addDays(now, 90)), 89))
    }
  },
  'next-year': {
    label: 'Next year',
    value: {
      startDate: formatToIsoString(new Date(now.getFullYear() + 1, 0, 1)),
      endDate: formatToIsoString(new Date(now.getFullYear() + 1, 11, 31))
    }
  }
};

export const getDateRange = (option) => {
  return dateRanges[option]?.value || { startDate: null, endDate: null };
};

export const formatDateToStartOfDay = (date) => {
  if (date) {
    const formattedDate = formatToIsoString(new Date(date));
    return formattedDate.split('T')[0] + 'T00:00:00.000Z';
  }
  return null;
};

export const formatDateToEndOfDay = (date) => {
  if (date) {
    const formattedDate = formatToIsoString(new Date(date));
    return formattedDate.split('T')[0] + 'T23:59:59.999Z';
  }
  return null;
};
